var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_50004)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.7444C17.2727 19.7626 15.6364 21.3989 13.6182 21.3989C11.6 21.3989 9.96362 19.7626 9.96362 17.7444C9.96362 15.7262 11.6 14.0898 13.6182 14.0898C15.6364 14.0898 17.2727 15.7262 17.2727 17.7444Z",
    fill: "#7C0EE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.3088C18 19.327 16.3636 20.9634 14.3455 20.9634C12.3273 20.9634 10.6909 19.327 10.6909 17.3088C10.6909 15.2907 12.3273 13.6543 14.3455 13.6543C16.3636 13.6543 18 15.2907 18 17.3088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0182 17.3094C16.0182 18.2367 15.2727 18.9822 14.3637 18.9822C13.4546 18.9822 12.7091 18.2367 12.7091 17.3094C12.7091 16.3822 13.4546 15.6367 14.3637 15.6367C15.2727 15.6549 16.0182 16.4004 16.0182 17.3094Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7272 16.5625C13.7272 16.9806 13.3818 17.3261 12.9636 17.3261C12.5454 17.3261 12.2 16.9806 12.2 16.5625C12.2 16.1443 12.5454 15.7988 12.9636 15.7988C13.4 15.7988 13.7272 16.1261 13.7272 16.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4182 17.7445C29.4182 19.7627 27.7819 21.3991 25.7637 21.3991C23.7455 21.3991 22.1091 19.7627 22.1091 17.7445C22.1091 15.7264 23.7455 14.09 25.7637 14.09C27.8 14.0718 29.4182 15.7264 29.4182 17.7445Z",
    fill: "#7C0EE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.509 20.9634C28.5274 20.9634 30.1636 19.3272 30.1636 17.3088C30.1636 15.2905 28.5274 13.6543 26.509 13.6543C24.4907 13.6543 22.8545 15.2905 22.8545 17.3088C22.8545 19.3272 24.4907 20.9634 26.509 20.9634Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2727 17.3093C28.2727 18.2548 27.509 19.0366 26.5636 19.0366C25.6181 19.0366 24.8545 18.2729 24.8545 17.3093C24.8545 16.3638 25.6181 15.582 26.5636 15.582C27.509 15.6002 28.2727 16.3638 28.2727 17.3093Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9272 16.5279C25.9272 16.9643 25.5817 17.3097 25.1453 17.3097C24.709 17.3097 24.3635 16.9643 24.3635 16.5279C24.3635 16.0915 24.709 15.7461 25.1453 15.7461C25.5817 15.7461 25.9272 16.0915 25.9272 16.5279Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8363 16.2361C17.3818 14.7452 15.9818 13.6543 14.3454 13.6543C12.709 13.6543 11.3272 14.7452 10.8545 16.2361H17.8363Z",
    fill: "#B77CEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.2361C29.5455 14.7452 28.1455 13.6543 26.5091 13.6543C24.8727 13.6543 23.4909 14.7452 23.0182 16.2361H30Z",
    fill: "#B77CEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.7455 24.9055C13.7455 27.1237 11.9455 28.9419 9.72729 28.9419C7.50911 28.9419 5.70911 27.1419 5.70911 24.9055C5.70911 22.6873 7.50911 20.8691 9.72729 20.8691C11.9455 20.8691 13.7455 22.6691 13.7455 24.9055Z",
    fill: "url(#paint1_radial_40_50004)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3819 25.0871C33.3819 27.3053 31.5819 29.1235 29.3638 29.1235C27.1456 29.1235 25.3456 27.3235 25.3456 25.0871C25.3456 22.869 27.1456 21.0508 29.3638 21.0508C31.5819 21.0508 33.3819 22.8508 33.3819 25.0871Z",
    fill: "url(#paint2_radial_40_50004)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3091 12.397C14.9091 11.3061 12.8546 11.1789 11.6728 12.6698C11.4182 12.9789 11.8909 13.397 12.1455 13.088C13.1091 11.8698 14.7637 11.9789 15.8909 12.8698C16.2182 13.1061 16.6364 12.6516 16.3091 12.397Z",
    fill: "#7C0EE1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7818 11.9244C15.3818 10.8335 13.3272 10.7062 12.1454 12.1971C11.8909 12.5062 12.3636 12.9244 12.6181 12.6153C13.5818 11.3971 15.2363 11.5062 16.3636 12.3971C16.6909 12.6335 17.109 12.1789 16.7818 11.9244Z",
    fill: "#14110E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2182 12.397C26.8182 11.3061 24.7636 11.1789 23.5818 12.6698C23.3273 12.9789 23.8 13.397 24.0545 13.088C25.0182 11.8698 26.6727 11.9789 27.8 12.8698C28.1273 13.1061 28.5454 12.6516 28.2182 12.397Z",
    fill: "#7C0EE1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6908 11.9244C27.2908 10.8335 25.2363 10.7062 24.0545 12.1971C23.7999 12.5062 24.2726 12.9244 24.5272 12.6153C25.4908 11.3971 27.1454 11.5062 28.2726 12.3971C28.5999 12.6335 29.0181 12.1789 28.6908 11.9244Z",
    fill: "#14110E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25919 25.3411C15.2228 28.9593 23.9137 29.3957 30.8774 25.5411C31.0955 25.4139 31.3137 25.7593 31.0774 25.8866C23.9865 29.8139 15.1501 29.3775 8.05919 25.6866C7.82282 25.5775 8.02282 25.2139 8.25919 25.3411Z",
    fill: "#3B0523"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_50004",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#CC9EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C0EE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_50004",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.73047 24.8969) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_50004",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3669 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#DE278D",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodBad);
export default __webpack_public_path__ + "static/media/Mood_Bad.e664e60b375328a1bec2f79a41eb8f47.svg";
export { ForwardRef as ReactComponent };